var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferCart = function SvgTransferCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3H6.5a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1H11a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M4 12h7.61a1 1 0 0 1 .7.29l1.19 1.21M.5.5h1a1 1 0 0 1 1 1V10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.976 11.635q.006.125 0 .25a1.74 1.74 0 1 1 0-.25M8.5 7h1"
  }))));
};
export default SvgTransferCart;